import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    marginTop: 20,
    width: '90%',
    borderWidth: 1,
    borderColor: '#dbdbdb',
    borderRadius: 8,
    position: 'relative',
    marginBottom: 12
  },
  roomTitleContainer: {
    position: 'absolute',
    width: '100%',
    flexDirection: 'row-reverse',
    right: -12,
    top: -10
  },
  roomTitle: {
    backgroundColor: '#ffffff',
    paddingHorizontal: 10,
    borderBottomLeftRadius: 20,
    top: -12,
    fontSize: 10,
    flexDirection: 'row-reverse'
  },
  roomTitleLabel: {
    flexDirection: 'row-reverse',
    paddingLeft: 6
  },
  roomTitleWord: {
    color: '#ababab',
    marginLeft: 3
  },
  roomTitleValue: {},
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexWrap: 'nowrap'
  },
  contentColumn1: {
    paddingHorizontal: 10,
    paddingRight: 16,
    paddingVertical: 12,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderLeftWidth: 1,
    borderStyle: 'dashed',
    borderColor: '#dbdbdb'
  },
  contentColumn2: {
    paddingHorizontal: 10,
    paddingVertical: 12,
    paddingLeft: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  contentColumn3: {
    paddingHorizontal: 10,
    paddingVertical: 12,
    // Widest column: the nightly rates, one line per night with date and amount.
    flex: 1.5,
    display: 'flex',
    flexDirection: 'column',
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderStyle: 'dashed',
    borderColor: '#dbdbdb'
  },
  contentColumn4: {
    paddingHorizontal: 10,
    paddingVertical: 12,
    flex: 0.8,
    display: 'flex',
    flexDirection: 'column'
  },
  subject: {
    marginBottom: 10,
    alignItems: 'flex-end',
    textAlign: 'right'
  },
  subjectTitle: {
    fontSize: 9,
    color: 'grey'
  },
  subjectValue: {
    fontSize: 9,
    color: 'black',
    textAlign: 'right'
  },
  numberOfGuestsContainer: {
    flexDirection: 'row-reverse'
  }
})

export default styles
